import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CohortBandItem } from '../../../models/college-dashboard.model';

interface DonutSegment {
  label: string;
  band: string;
  count: number;
  percent: number;
  strokeColor: string;
  dashArray: string;
  dashOffset: number;
}

@Component({
  selector: 'app-cohort-donut',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cohort-donut.component.html',
  styleUrl: './cohort-donut.component.scss'
})
export class CohortDonutComponent implements OnChanges {
  @Input() kpis: { assessed: number; averageScore: number } = { assessed: 0, averageScore: 0 };
  @Input() cohort: CohortBandItem[] = [];

  readonly radius: number = 46;
  readonly circumference: number = 2 * Math.PI * 46; // ≈ 289.027

  segments: DonutSegment[] = [];

  readonly colors: Record<string, string> = {
    ready: '#16a34a',
    developing: '#d97706',
    'at-risk': '#e11d48'
  };

  ngOnChanges(changes: SimpleChanges): void {
    this.calculateSegments();
  }

  private calculateSegments(): void {
    const total = this.cohort.reduce((sum, item) => sum + item.count, 0) || 1;
    let accumulatedOffset = 0;

    this.segments = this.cohort.map((item) => {
      const sliceFraction = item.count / total;
      const sliceLength = sliceFraction * this.circumference;
      const gap = 3;
      const strokeLength = Math.max(0, sliceLength - gap);

      const segment: DonutSegment = {
        label: item.label,
        band: item.band,
        count: item.count,
        percent: item.percent,
        strokeColor: this.colors[item.band] || '#5438d8',
        dashArray: `${strokeLength} ${this.circumference - strokeLength}`,
        dashOffset: -accumulatedOffset
      };

      accumulatedOffset += sliceLength;
      return segment;
    });
  }
}
